export default {
  LOAD_META_TRANSLATIONS: '@WS/TEMPLATE/LOAD_META_TRANSLATIONS',
  SET_DESIGN_AUTOMATION_CONFIG: '@WS/TEMPLATE/SET_DESIGN_AUTOMATION_CONFIG',
  SET_EMPTY_PAGE: '@WS/TEMPLATE/SET_EMPTY_PAGE',
  SET_EXTENSIONS: '@WS/TEMPLATE/SET_EXTENSIONS',
  SET_META_TRANSLATIONS: '@WS/TEMPLATE/SET_META_TRANSLATIONS',
  SET_TEMPLATE_BUILD_SLUG: '@WS/TEMPLATE/SET_TEMPLATE_BUILD_SLUG',
  SET_PAGE_CONTAINER_SELECTOR: '@WS/TEMPLATE/SET_PAGE_CONTAINER_SELECTOR',
  SET_PAGE_TEMPLATES: '@WS/TEMPLATE/SET_PAGE_TEMPLATES',
  SET_PAGE_TEMPLATE_HTML: '@WS/TEMPLATE/SET_PAGE_TEMPLATE_HTML',
  SET_SOCIAL_ICONS: '@WS/TEMPLATE/SET_SOCIAL_ICONS',
  SET_VARIABLES: '@WS/TEMPLATE/SET_VARIABLES',
  SET_SUPPORTED_BLOCK_CATEGORIES_FOR_REGENERATION:
    '@WS/TEMPLATE/SET_SUPPORTED_BLOCK_CATEGORIES_FOR_REGENERATION',
};
